<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { operProt } from "@/api/tracker/prot";
import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
export default {
  name: "port",
  components: {
    cTable
  },
  async mounted() {},
  methods: {},
  data() {
    let statusList = [
      { label: this.$t("YES"), value: "YES" },
      { label: this.$t("NO"), value: "NO" }
    ];
    return {
      methods: {
        list: p => {
          p["method"] = p["method"] ? p["method"] : "get";
          return operProt(p);
        }
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              row["method"] = row.id ? "PUT" : "POST";
              console.log(row);
              this.$page.handleRequestMethods("list", row, true).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  type: "string",
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  type: "string",
                  message: "code cannot be empty",
                  trigger: "blur"
                }
              ],
              country: [
                {
                  required: true,
                  message: "country cannot be empty",
                  trigger: "blur"
                }
              ],
              is_from: [
                {
                  required: true,
                  type: "string",
                  message: "is_from cannot be empty",
                  trigger: "change"
                }
              ],
              is_to: [
                {
                  required: true,
                  type: "string",
                  message: "is_to cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { name: 24 },
            { code: 24 },
            { country: 24 },
            { is_from: 24 },
            { is_to: 24 }
          ],
          fields: [
            {
              key: "name",
              name: () => this.$t("portName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("portName");
              }
            },
            {
              key: "code",
              name: () => this.$t("portCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("portCode");
              }
            },
            {
              key: "country",
              name: () => this.$t("ownerCountry"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("ownerCountry");
              },
              options: [],
              config: {
                value: "cn_title",
                label: "cn_title"
              },
              methods: {
                async list({ field, searchForm }) {
                  let res = (await getCountry()).data.payload.rows;
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "is_from",
              name: () => this.$t("startGang"),
              component: "Radio",
              bind: {
                border: true
              },
              options: statusList,
              default: "NO"
            },
            {
              key: "is_to",
              name: () => this.$t("endGang"),
              component: "Radio",
              bind: {
                border: true
              },
              options: statusList,
              default: "NO"
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          // {
          //   key: "isUnique",
          //   placeholder() {
          //     return this.$t("select") + this.$t("is_unique");
          //   },
          //   component: "Select",
          //   options: statusList
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 498
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              console.log(this);
              this.getModal("add").open(null, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("portName"),
          key: "name",
          align: "center",
          minWidth: 150
        },
        {
          name: this.$t("portCode"),
          key: "code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("ownerCountry"),
          key: "country",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("whether") + this.$t("startGang"),
          key: "is_from",
          align: "center",
          minWidth: 100,
          methods: {
            render({ value }) {
              return statusList.find(item => item.value == value).label;
            }
          }
        },
        {
          name: () => this.$t("whether") + this.$t("endGang"),
          key: "is_to",
          align: "center",
          minWidth: 100,
          methods: {
            render({ value }) {
              return statusList.find(item => item.value == value).label;
            }
          }
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 499
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 497
            }
          ],

          methods: {
            async updateFun({ row }) {
              let data = {
                methods: "get",
                id: row.id
              };
              let res = await this.handleRequestMethods("list", data);
              this.getModal("add").open(
                {
                  name: res.payload.name,
                  code: res.payload.code,
                  country: res.payload.country,
                  is_from: res.payload.is_from,
                  is_to: res.payload.is_to,
                  id: row.id
                },
                function() {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("portName") +
                  "：" +
                  row.name +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete"
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
